import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  const API_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Check both hash and query params for session_id (mobile compatibility)
      const hash = window.location.hash;
      const search = window.location.search;
      
      let sessionId = null;
      
      // Try hash first
      const hashMatch = hash.match(/session_id=([^&]+)/);
      if (hashMatch) {
        sessionId = hashMatch[1];
      }
      
      // Fall back to query params (some mobile browsers use this)
      if (!sessionId) {
        const searchParams = new URLSearchParams(search);
        sessionId = searchParams.get('session_id');
      }

      if (!sessionId) {
        console.error('No session_id found in URL');
        navigate('/admin/login');
        return;
      }

      try {
        const response = await fetch(`${API_URL}/api/auth/session`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (response.ok) {
          const userData = await response.json();
          setUser(userData);
          // Clear the hash/query and navigate to admin dashboard
          window.history.replaceState(null, '', '/admin');
          navigate('/admin', { state: { user: userData }, replace: true });
        } else {
          const error = await response.json();
          console.error('Auth failed:', error);
          navigate('/admin/login', { 
            state: { error: error.detail || 'Authentication failed' },
            replace: true 
          });
        }
      } catch (error) {
        console.error('Auth error:', error);
        navigate('/admin/login', { 
          state: { error: 'An error occurred during authentication' },
          replace: true 
        });
      }
    };

    processAuth();
  }, [navigate, setUser, API_URL]);

  return (
    <div className="min-h-screen bg-[#1a1f1a] flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#c9a55a] mx-auto mb-4"></div>
        <p className="text-[#f5f3ed]">Authenticating...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
